// extracted by mini-css-extract-plugin
export default {"buttonLogOut":"logoutComponent_buttonLogOut__hYs1-","btn":"logoutComponent_btn__S6W+b"};